import { render, staticRenderFns } from "./DashboardVista.vue?vue&type=template&id=af29ab64&scoped=true&"
import script from "./DashboardVista.vue?vue&type=script&lang=js&"
export * from "./DashboardVista.vue?vue&type=script&lang=js&"
import style0 from "./DashboardVista.vue?vue&type=style&index=0&id=af29ab64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af29ab64",
  null
  
)

export default component.exports